
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
@Component({
})
export default class InfoButton extends Vue {
    @Prop()
    propertyId!: string;

    @Prop()
    propertyType!: string;

    handleClick() {
        let eventName = this.propertyType + "Click"
        //console.log("emiting " + eventName)
        this.$emit(eventName, this.propertyId)
    };
}
